import { useEffect, useState } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEye, IconEyeOff, IconLoader2 } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useFetch } from "../../helpers/useFetch.js";

export default function QuestVisibilityButton({ quest, onUpdate }) {
  const [isHidden, setIsHidden] = useState(!!quest.hidden);
  const [loading, setLoading] = useState(false);

  // Sync s propem, aby ikona neukazovala zastaralý stav po refetchi/editaci.
  useEffect(() => {
    setIsHidden(!!quest.hidden);
  }, [quest.hidden]);

  const handleToggle = async (e) => {
    e.stopPropagation();
    const newHidden = !isHidden;

    setIsHidden(newHidden);
    onUpdate(quest.id, newHidden);

    setLoading(true);
    const { url, ...rest } = quest;
    const payload = {
      ...rest,
      hidden: newHidden,
      camp_id: quest.camp.id,
    };
    if (url && url.trim()) payload.url = url;

    try {
      const res = await useFetch(`/pc/quests/${quest.id}`, "PUT", payload);
      if (res.status !== "ok") {
        throw new Error("Bad status");
      }
      toast.success(`Quest byl úspěšně ${newHidden ? "skryt" : "zobrazen"}`);
    } catch (err) {
      setIsHidden(!!quest.hidden);
      onUpdate(quest.id, !!quest.hidden);
      toast.error(`Nastala chyba při ${newHidden ? "skrytí" : "zobrazení"} questu`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip
      position="top"
      withArrow
      transition="fade"
      transitionDuration={200}
      label={isHidden ? "Zobrazit quest" : "Skrýt quest"}>
      <ActionIcon variant="light" color={loading ? "gray" : isHidden ? "red" : "green"} onClick={handleToggle}>
        {loading ? (
          <IconLoader2 stroke={1.5} size={15} className="animate-spin" />
        ) : isHidden ? (
          <IconEye stroke={1.5} size={18} />
        ) : (
          <IconEyeOff stroke={1.5} size={18} />
        )}
      </ActionIcon>
    </Tooltip>
  );
}
